import {
  Box, Button, ClickAwayListener, Grow, Paper, Popper,
} from '@mui/material'
import { useEffect, useRef, useState } from 'react'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz'

const Index = ({
  children,
  customBtnIcon,
  textBtnStyle,
  disabled,
  customStyle, preventClosePopUp,
}) => {
  const [popperStatus, setPopperStatus] = useState(false)
  const anchorRef = useRef(null)
  const prevOpen = useRef(popperStatus)

  const handleToggle = () => {
    if (!disabled) {
      setPopperStatus((prev) => !prev)
    }
  }

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return
    }

    setPopperStatus(false)
  }

  useEffect(() => {
    if (prevOpen.current === true && popperStatus === false) {
      anchorRef?.current.focus()
    }

    prevOpen.current = popperStatus
  }, [popperStatus])

  return (
    <Box sx={styles.changeStatusContainer}>
      <Button
        ref={anchorRef}
        aria-controls={popperStatus ? 'menu-list-grow' : undefined}
        aria-haspopup="true"
        sx={[styles.moreActionsButton,
          customStyle, textBtnStyle &&
          styles.textStyle, disabled && styles.disabledMoreActionsButton,
        ]}
        onClick={handleToggle}
        disabled={disabled}

      >
        { customBtnIcon || <MoreHorizIcon sx={styles.moreHorizIcon} />}
      </Button>
      <Popper
        open={popperStatus}
        anchorEl={anchorRef?.current}
        role={undefined}
        transition
        disablePortal
        sx={styles.changeStatusPopper}
        placement="bottom-start"
      >
        {({
          TransitionProps,
          placement,
        }) => (
          <Grow
            {...TransitionProps}
            style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
          >
            <Paper sx={styles.popperPaper} onClick={preventClosePopUp || handleClose}>
              <ClickAwayListener onClickAway={handleClose}>
                <Box sx={styles.paperContainer}>
                  {children}
                </Box>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </Box>
  )
}
const styles = {
  changeStatusContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  moreActionsButton: {
    height: { xs: '30px', sm: '40px' },
    minWidth: { xs: '30px', sm: '40px' },
    borderRadius: '12px',
    border: 'unset',
    backgroundColor: 'transparent',
    color: 'text.hint',
    overflow: 'hidden',
    padding: '0',
  },
  textStyle: {
    width: '100%',
    border: 0,
    backgroundColor: 'transparent',
    textTransform: 'capitalize',
    color: 'text.primary',
    fontSize: '16px',
  },
  moreHorizIcon: {
    color: 'text.disabled',
  },
  disabledMoreActionsButton: {
    backgroundColor: 'grey.100',
    cursor: 'not-allowed',
  },
  changeStatusPopper: {
    minWidth: '200px',
    zIndex: 9999,
  },
  popperPaper: {
    borderRadius: '12px',
  },
  paperContainer: {
    padding: '10px 15px',
    height: { xs: '550px', sm: 'initial' },
  },
}
export default Index
